import { render, staticRenderFns } from "./ShowModalityContact.vue?vue&type=template&id=1eb72088"
import script from "./ShowModalityContact.vue?vue&type=script&lang=js"
export * from "./ShowModalityContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports